export type Lang = 'ar' | 'en' | 'fr';

export const translations = {
  en: {
    // Common
    appName: 'Momira',
    close: 'Close',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    copy: 'Copy',
    copied: 'Copied!',
    settings: 'Settings',
    signOut: 'Sign Out',
    back: 'Back',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    share: 'Share',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    // Landing
    heroTitle: 'One Event, One Beautiful Story',
    heroSubtitle: 'Collect every moment from every guest. Professional-quality photo gathering for your special occasions.',
    getStarted: 'Get Started',
    howItWorks: 'How it works',
    step1Title: 'Create Your Event',
    step1Desc: 'Set up your event in seconds with a unique QR code for guests to join.',
    step2Title: 'Guests Join & Upload',
    step2Desc: 'Guests scan your QR code and start uploading photos instantly.',
    step3Title: 'Curate & Share',
    step3Desc: 'Review, select, and share the best moments with everyone.',
    features: 'Everything you need',
    everythingYouNeed: 'Everything you need. Nothing you don\'t.',
    feature1Title: 'Capture Together',
    feature1Desc: 'Guests join via QR code and shoot from every angle.',
    feature2Title: 'Delayed Reveal',
    feature2Desc: 'Photos stay sealed until the moment ends, building suspense.',
    feature3Title: 'Private & Secure',
    feature3Desc: 'Only invited guests see your album. End-to-end privacy.',
    feature4Title: 'AI Photo Effects',
    feature4Desc: 'Cinematic, Anime, B&W, Slow-Mo — 10 Higgsfield templates.',
    feature5Title: 'Smart Curation',
    feature5Desc: 'AI picks the best shots and assembles a highlight reel.',
    feature6Title: 'One-tap Sharing',
    feature6Desc: 'Instagram, TikTok, Snapchat — share with a single tap.',
    pricing: 'Pricing',
    faq: 'Frequently Asked Questions',
    everythingYouWantedToKnow: 'Everything you wanted to know.',
    testimonials: 'Testimonials',
    lovedByHosts: 'Loved by hosts worldwide',
    login: 'Sign In',
    createYourEvent: 'Create your event',
    joinAnEvent: 'Join an event',
    captureYourDay: 'Capture your day',
    throughEveryonesEyes: "through everyone's eyes.",
    premiumPrivatePhotoSharing: 'Momira is a premium, private photo sharing app for events. Guests join via QR code, snap memorable photos, and the album reveals after the event.',
    nowWithAI: 'Now with AI-powered photo curation',
    chooseHowToUse: 'Choose how you want to use Momira',
    user: 'User',
    guest: 'Guest',
    admin: 'Admin',
    flash: 'Flash',
    userDesc: 'Create events, invite guests, and manage your albums.',
    guestDesc: 'Scan a QR code or enter an event code to join and share photos.',
    adminDesc: 'Manage all events, approve photos, and view analytics.',
    howADayBecomes: 'How a day becomes a film.',
    threeSimpleSteps: 'Three simple steps. Zero friction.',
    step: 'STEP',
    createAFilm: 'Create a film',
    inviteYourPeople: 'Invite your people',
    captureTogether: 'Capture Together',
    createFilmDesc: 'Name your film, set how long it will stay open, and what kind of moment it is for.',
    inviteDesc: 'Share your film link or QR code and invite friends to capture the day with you.',
    captureDesc: 'Take photos throughout the day, every shot fills your shared film roll.',
    perfectForEveryMoment: 'Perfect for every moment.',
    fromWhisperedToNeon: 'From whispered "I do"s to neon dance floors.',
    wedding: 'Wedding',
    birthday: 'Birthday',
    trip: 'Trip',
    party: 'Party',
    corporate: 'Corporate',
    other: 'Other',
    weddingDesc: 'Capture every emotion from every guest.',
    birthdayDesc: 'See the party from all perspectives.',
    tripDesc: 'Collect travel memories together.',
    partyDesc: 'The best candid moments, guaranteed.',
    lifeHappens: "Life happens Momira.",
    dontLetItFade: "Don't let it fade away.",
    startFirstEvent: 'Start your first event in under 60 seconds. Free for up to 50 guests.',
    seePricing: 'See pricing',
    createForFree: 'Create for free',
    footerTagline: 'A single day becomes timeless, when remembered together.',
    faq1Q: 'What is Momira and how does it work?',
    faq1A: 'Momira is a private photo sharing app for events. You create a "film" (event), invite guests with a QR code, and everyone captures photos throughout the day. Photos are hidden until the event ends, then revealed to everyone at once.',
    faq2Q: 'Can I use Momira on an Android phone?',
    faq2A: 'Yes! Momira works on any device with a web browser. Guests can join via QR code without downloading anything.',
    faq3Q: 'How do I create a film on Momira?',
    faq3A: 'Sign up with your phone number, tap "New Event", name your film, choose the type, set how long it stays open, and share the QR code with your guests.',
    faq4Q: 'Can friends join without creating an account?',
    faq4A: 'Guests need to sign in with their phone number to upload photos and view the album. This ensures privacy and security for your event.',
    faq5Q: 'Who can see the photos I upload?',
    faq5A: 'Only guests invited to your event can see the photos. Your event is private by default. Hosts can review and approve photos before they appear.',
    faq6Q: 'How long does it take for a film to develop?',
    faq6A: 'Photos are revealed automatically at the time you set when creating the event. You can choose to reveal them immediately after the event ends or at a specific date.',
    faq7Q: 'Can I download my photos after the film develops?',
    faq7A: 'Yes — download the full ZIP album or back it up directly to Google Drive. Every photo is preserved at original resolution.',
    faq8Q: 'What kinds of moments is Momira best for?',
    faq8A: 'Momira is perfect for weddings, birthdays, trips, parties, corporate events, and any special occasion you want to remember together.',
    faq9Q: 'Why is it called Momira?',
    faq9A: 'Momira represents "Moments" and "Memory" — capturing the moments that become memories we cherish forever.',
    // Auth
    phoneAuth: 'Phone Authentication',
    passwordAuth: 'Password Authentication',
    sendCode: 'Send Code',
    verifyCode: 'Verify Code',
    resendCode: 'Resend Code',
    enterPhone: 'Enter your phone number',
    enterCode: 'Enter verification code',
    enterPassword: 'Enter password',
    setPassword: 'Set Password',
    updatePassword: 'Update Password',
    passwordMinChars: 'Password must be at least 6 characters',
    otpSent: 'OTP sent! Check your messages.',
    loginSuccess: 'Login successful!',
    welcomeToMomira: 'Welcome to Momira!',
    passwordSaved: 'Password saved! You can use it next time.',
    passwordUpdated: 'Password updated!',
    invalidPhone: 'Please enter a valid phone number with country code',
    invalidOtp: 'Please enter the OTP code',
    invalidVerification: 'Invalid verification. Please try again.',
    tooManyAttempts: 'Too many attempts',
    tooManyAttemptsDesc: 'Please wait a few minutes before trying again.',
    invalidPhoneFormat: 'Invalid phone number format',
    invalidPhoneFormatDesc: 'Enter your full number with country code, e.g. +966501234567. No spaces.',
    failedSendOtp: 'Failed to send OTP',
    invalidOtpCode: 'Invalid OTP',
    failedSavePassword: 'Failed to save password',
    failedUpdatePassword: 'Failed to update password',
    emailPasswordDisabled: 'Email/Password sign-in is disabled in Firebase Console.',
    emailPasswordDisabledDesc: 'Go to Authentication > Sign-in method and enable "Email/Password".',
    welcomeBack: 'Welcome back!',
    enterYourPassword: 'Please enter your password',
    invalidPhoneNoCountry: 'Invalid phone number format',
    invalidPhoneNoCountryDesc: 'Enter your full number with country code, e.g. +966501234567',
    invalidPhoneOrPassword: 'Invalid phone number or password',
    invalidPhoneOrPasswordDesc: 'No password found for this number. Sign in with OTP first to set a password.',
    emailPasswordDisabledAlt: 'Email/Password sign-in is disabled',
    emailPasswordDisabledAltDesc: 'Ask the admin to enable it in Firebase Console > Authentication > Sign-in method.',
    invalidPhoneOrPasswordAlt: 'Invalid phone or password',
    eventNamePlaceholder: 'Sarah & Mike Wedding',
    descriptionPlaceholder: 'A few words about your event...',
    fillRequiredFields: 'Please fill in all required fields',
    signInFirst: 'Please sign in first',
    eventCreated: 'Event created successfully',
    failedCreateEvent: 'Failed to create event',
    // Dashboard
    yourEvents: 'Your Events',
    noEvents: 'No events yet',
    createEvent: 'Create Event',
    newEvent: 'New Event',
    scanQR: 'Scan QR',
    pending: 'Pending',
    gallery: 'Gallery',
    events: 'Events',
    noDate: 'No date',
    failedLoadEvents: 'Failed to load events',
    noPhone: 'No phone',
    notSet: 'Not set',
    recently: 'Recently',
    enableEmailPassword: 'Enable it in Authentication > Sign-in method.',
    failedGenerateAlbum: 'Failed to generate album',
    failedDeleteEvent: 'Failed to delete event',
    failedLoadAnalytics: 'Failed to load analytics',
    aiCurationFailed: 'AI curation failed',
    failedGenerateReel: 'Failed to generate highlight reel',
    allowPopups: 'Please allow popups to connect Google Drive',
    // Pricing features
    pricingFeature1: 'Guests join via QR code or link (no app download)',
    pricingFeature2: 'Unlimited photos per guest',
    pricingFeature3: 'Set how long your film stays open',
    pricingFeature4: 'Private & secure — only invited guests see photos',
    pricingFeature5: 'One-tap QR code sharing',
    pricingFeature6: 'Photo filters and AI curation',
    pricingFeature7: 'See exactly who took each photo',
    pricingFeature8: 'Download full album after reveal',
    // Pricing FAQs
    pricingFaq1Q: 'What is Momira and how does it work?',
    pricingFaq1A: 'Momira is a private photo sharing app for events. You create a "film" (event), invite guests with a QR code, and everyone captures photos throughout the day. Photos are hidden until the event ends, then revealed to everyone at once.',
    pricingFaq2Q: 'Can I use Momira on an Android phone?',
    pricingFaq2A: 'Yes! Momira works on any device with a web browser. Guests can join via QR code without downloading anything. The web app is fully responsive and works on both iOS and Android.',
    pricingFaq3Q: 'How do I create a film on Momira?',
    pricingFaq3A: 'Sign up with your phone number, tap "New Event", name your film, choose the type (wedding, party, trip, etc.), set how long it stays open, and share the QR code with your guests.',
    pricingFaq4Q: 'Can friends join without creating an account?',
    pricingFaq4A: 'Guests need to sign in with their phone number to upload photos and view the album. This ensures privacy and security for your event.',
    pricingFaq5Q: 'Who can see the photos I upload?',
    pricingFaq5A: 'Only guests invited to your event can see the photos. Your event is private by default. Admins can review and approve photos before they appear.',
    pricingFaq6Q: 'How long does it take for a film to develop?',
    pricingFaq6A: 'You set the reveal time when creating the event. It can be immediate, after a few hours, or even days later. The anticipation is half the fun!',
    pricingFaq7Q: 'Can I download my photos after the film develops?',
    pricingFaq7A: 'Yes, you can download the full album as a zip file once the film is revealed. Every photo is preserved in high quality.',
    pricingFaq8Q: 'What kinds of moments is Momira best for?',
    pricingFaq8A: 'Weddings, birthdays, parties, trips, corporate events, concerts — any moment where multiple people are capturing memories together.',
    pricingFaq9Q: 'Why is it called Momira?',
    pricingFaq9A: 'Because life happens Momira. Every moment is unique and irreplaceable. Momira helps you capture these moments through everyone\'s eyes, not just your own.',
    classicWedding: 'Classic Wedding',
    classicWeddingDesc: 'Private event with host approval for every photo. Perfect for elegant weddings.',
    birthdayBash: 'Birthday Bash',
    birthdayBashDesc: 'Fun and casual. Auto-approve photos so the party never stops!',
    adventureTrip: 'Adventure Trip',
    adventureTripDesc: 'Share travel memories with friends. Moderate limits for group trips.',
    corporateEvent: 'Corporate Event',
    corporateEventDesc: 'Professional setting with strict approval for brand safety.',
    graduationDay: 'Graduation Day',
    graduationDayDesc: 'Capture every cap toss and proud moment. Public sharing on.',
    engagementParty: 'Engagement Party',
    engagementPartyDesc: 'Romantic moments only — host approves every shot.',
    // Admin
    adminDashboard: 'Admin Dashboard',
    overview: 'Overview',
    photos: 'Photos',
    guests: 'Guests',
    analytics: 'Analytics',
    totalEvents: 'Total Events',
    totalPhotos: 'Total Photos',
    activeGuests: 'Active Guests',
    pendingPhotos: 'Pending Photos',
    approvalQueue: 'Approval Queue',
    recentGuests: 'Recent Guests',
    allEvents: 'All Events',
    eventManagement: 'Event Management',
    photoApproval: 'Photo Approval Queue',
    guestManagement: 'Guest Management',
    approve: 'Approve',
    reject: 'Reject',
    remove: 'Remove',
    noPendingPhotos: 'No pending photos',
    noGuests: 'No guests found',
    // Settings
    profile: 'Profile',
    password: 'Password',
    passwordSet: 'Set',
    joined: 'Joined',
    administrator: 'Administrator',
    backToDashboard: 'Back to Dashboard',
    // Event Modal
    eventDetails: 'Event Details',
    type: 'Type',
    status: 'Status',
    startDate: 'Start Date',
    endDate: 'End Date',
    revealDate: 'Reveal Date',
    maxPhotosPerGuest: 'Max Photos/Guest',
    approval: 'Approval',
    approvalRequired: 'Required',
    approvalAuto: 'Auto',
    privateEvent: 'Private Event',
    guestSharing: 'Guest Sharing',
    yes: 'Yes',
    no: 'No',
    on: 'On',
    off: 'Off',
    identifiers: 'Identifiers',
    eventId: 'Event ID',
    qrCode: 'QR Code',
    host: 'Host',
    links: 'Links',
    viewEvent: 'View Event',
    qrPage: 'QR Page',
    copyLink: 'Copy Link',
    dates: 'Dates',
    // Create Event
    dateTime: 'Date & Time',
    privacyPermissions: 'Privacy & Permissions',
    creating: 'Creating...',
    eventName: 'Event Name',
    description: 'Description',
    continue: 'Continue',
    albumRevealDate: 'Album Reveal Date',
    requireHostApproval: 'Require Host Approval',
    allowGuestSharing: 'Allow Guest Sharing',
    albumRevealDateDesc: 'When should the photos be revealed to guests?',
    autoApproveTrustedGuests: 'Auto-Approve Trusted Guests',
    allowCoHost: 'Allow Co-Hosts',
    allowCoHostDesc: 'Guests can help manage the event',
    // Pricing
    choosePlan: 'Choose a plan',
    pricingDesc: 'You only pay once per event. No subscriptions, no renewals.',
    participants: 'Participants',
    free: 'Free',
    perEvent: 'per event',
    featuresIncluded: 'What\'s included',
    upToParticipants: 'Up to',
    canJoin: 'can join your event',
    createFreeEvent: 'Create Free Event',
    noCreditCard: 'No credit card required for free events',
    // QR
    manualEntry: 'Manual Entry',
    enterEventCode: 'Enter event code',
    join: 'Join Event',
    joining: 'Joining event...',
    joinSuccess: 'Joined event successfully!',
    joinFailed: 'Failed to join event',
    joiningEvent: 'Event found! Joining...',
    alreadyInEvent: 'You are already in this event!',
    scanOrEnter: 'Scan a QR code or enter the event code manually.',
    tapToScan: 'Tap to start scanning',
    cameraAccessDenied: 'Camera access denied. Please use manual entry.',
    // Camera
    takePhoto: 'Take Photo',
    retake: 'Retake',
    upload: 'Upload',
    remainingShots: 'Remaining shots',
    shotsLeft: 'shots left',
    payAndCreate: 'Pay & Create Event',
    noEventSelected: 'No event selected',
    goToDashboard: 'Go to Dashboard',
    photoUploaded: 'Photo uploaded!',
    uploadFailed: 'Upload failed',
    // Event Detail
    like: 'Like',
    comment: 'Comment',
    download: 'Download',
    all: 'All',
    yours: 'Yours',
    social: 'Social',
    grid: 'Grid',
    list: 'List',
    eventNotFound: 'Event not found',
    failedToLoadEvent: 'Failed to load event',
    checkOutPhoto: 'Check out this photo from our event!',
    publicEvent: 'Public',
    scanToJoin: 'Scan to join this event',
    eventCode: 'Event Code',
    allPhotos: 'All Photos',
    shareThisEvent: 'Share This Event',
    spreadTheWord: 'Spread the word and get more guests to join!',
    photoChallenges: 'Photo Challenges',
    shares: 'Shares',
    reach: 'Reach',
    engagement: 'Engagement',
    sharingEnabled: 'Sharing enabled',
    noPhotosYet: 'No photos yet',
    takeFirstPhoto: 'Take First Photo',
    albumLocked: 'Album is locked until reveal time',
    revealsOn: 'Reveals on',
    aiCurationComplete: 'AI curation complete!',
    totalGuests: 'Total Guests',
    approved: 'Approved',
    topUploaders: 'Top Uploaders',
    confirmDelete: 'Are you sure you want to delete this event?',
    eventDeleted: 'Event deleted',
    noChallengesYet: 'No challenges yet',
    hostCanCreate: 'Host can create photo challenges',
    addComment: 'Add a comment...',
    post: 'Post',
    templates: 'Quick Start Templates',
    maxGuests: 'Max Guests',
    maxGuestsDesc: 'Guests beyond this limit will need an upgrade.',
    guestbook: 'Guestbook',
    emailInvite: 'Invite by Email',
    sendInvite: 'Send',
    leaveAMessage: 'Leave a message for the host',
    writeMessage: 'Write a message...',
    send: 'Send',
    watermarkText: 'Watermark Text',
    watermarkDesc: 'Text to overlay on downloaded photos.',
  },
  ar: {
    // Common
    appName: 'موميرا',
    close: 'إغلاق',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    view: 'عرض',
    copy: 'نسخ',
    copied: 'تم النسخ!',
    settings: 'الإعدادات',
    signOut: 'تسجيل الخروج',
    back: 'رجوع',
    search: 'بحث',
    filter: 'تصفية',
    export: 'تصدير',
    share: 'مشاركة',
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجاح',
    // Landing
    heroTitle: 'حدث واحد، قصة جميلة',
    heroSubtitle: 'اجمع كل لحظة من كل ضيف. جمع الصور بجودة احترافية لمناسباتك الخاصة.',
    getStarted: 'ابدأ الآن',
    howItWorks: 'كيف يعمل',
    step1Title: 'أنشئ حدثك',
    step1Desc: 'جهز حدثك في ثوانٍ مع رمز QR فريد للضيوف للانضمام.',
    step2Title: 'ينضم الضيوف ويرفعون الصور',
    step2Desc: 'يضيف الضيوف صورهم على الفور باستخدام رمز QR.',
    step3Title: 'دقق وشارك',
    step3Desc: 'راجع وحدد أفضل اللحظات وشاركها مع الجميع.',
    features: 'كل ما تحتاجه',
    everythingYouNeed: 'كل ما تحتاجه. لا شيء لا تحتاجه.',
    feature1Title: 'التقطوا معًا',
    feature1Desc: 'ينضم الضيوف عبر رمز QR والتقطوا من كل الزوايا.',
    feature2Title: 'كشف متأخر',
    feature2Desc: 'تبقى الصور مغلقة حتى ينتهي الحدث، مما يبني التشويق.',
    feature3Title: 'خاص وآمن',
    feature3Desc: 'الضيوف المدعوون فقط يرون ألبومك. خصوصية تامة.',
    feature4Title: 'تأثيرات الصور بالذكاء الاصطناعي',
    feature4Desc: 'سينمائي، أنمي، أبيض وأسود، بطيء — 10 قوالب Higgsfield.',
    feature5Title: 'اختيار ذكي',
    feature5Desc: 'يختار الذكاء الاصطناعي أفضل اللقطات ويجمع مقطعًا مميزًا.',
    feature6Title: 'مشاركة بنقرة واحدة',
    feature6Desc: 'إنستغرام، تيك توك، سناب شات — شارك بنقرة واحدة.',
    pricing: 'الأسعار',
    faq: 'الأسئلة الشائعة',
    everythingYouWantedToKnow: 'كل ما أردت معرفته.',
    testimonials: 'شهادات',
    lovedByHosts: 'محبوب من المضيفين حول العالم',
    login: 'تسجيل الدخول',
    createYourEvent: 'أنشئ فعاليتك',
    joinAnEvent: 'انضم لفعالية',
    captureYourDay: 'اجعل لحظاتك',
    throughEveryonesEyes: 'تُروى بعيون الجميع.',

    premiumPrivatePhotoSharing: 'تطبيق Momira هو تطبيق مشاركة الصور المتميز والخاص للفعاليات. ينضم الضيوف عبر رمز QR، يلتقطون صورًا لا تُنسى، ويتم كشف الألبوم بعد الحدث.',
    nowWithAI: 'الآن مع الذكاء الاصطناعي لاختيار الصور',
    chooseHowToUse: 'اختر كيف تريد استخدام Momira',
    user: 'مستخدم',
    guest: 'ضيف',
    host: 'مضيف',
    admin: 'مدير',
    flash: 'فلاش',
    userDesc: 'أنشئ فعاليات، ادعُ ضيوفًا، ودير ألبوماتك.',
    guestDesc: 'امسح رمز QR أو أدخل رقم الفعالية للانضمام ومشاركة الصور.',
    adminDesc: 'أدر جميع الفعاليات، وافق على الصور، وشاهد التحليلات.',
    howADayBecomes: 'كيف يصبح اليوم فيلمًا.',
    threeSimpleSteps: 'ثلاث خطوات بسيطة. بدون تعقيد.',
    step: 'الخطوة',
    createAFilm: 'أنشئ فيلم',
    inviteYourPeople: 'ادعُ أصدقاءك',
    captureTogether: 'التقطوا معًا',
    createFilmDesc: 'سمي فيلمك، حدد مدة فتحه، ونوع اللحظة.',
    inviteDesc: 'شارك رابط فيلمك أو رمز QR وادعُ الأصدقاء للتقاط اليوم معك.',
    captureDesc: 'التقط صورًا طوال اليوم، كل صورة تملأ رول الفيلم المشترك.',
    perfectForEveryMoment: 'مثالي لكل لحظة.',
    fromWhisperedToNeon: 'من الهمسات إلى أرضيات الرقص النيون.',
    wedding: 'زفاف',
    birthday: 'عيد ميلاد',
    trip: 'رحلة',
    party: 'حفلة',
    corporate: 'شركات',
    other: 'أخرى',
    weddingDesc: 'التقط كل مشاعر الضيوف.',
    birthdayDesc: 'شاهد الحفلة من كل الزوايا.',
    tripDesc: 'اجمع ذكريات السفر معًا.',
    partyDesc: 'أفضل اللحظات الطبيعية، مضمونة.',
    lifeHappens: 'الحياة تحدث مرة واحدة.',
    dontLetItFade: 'لا تدعها تتلاشى.',
    startFirstEvent: 'ابدأ فعاليتك الأولى في أقل من 60 ثانية. مجاني حتى 50 ضيف.',
    seePricing: 'شاهد الأسعار',
    createForFree: 'أنشئ مجانًا',
    footerTagline: 'اليوم الواحد يصبح خالدًا، عندما نتذكره معًا.',
    faq1Q: 'ما هو Momira وكيف يعمل؟',
    faq1A: 'Momira هو تطبيق مشاركة الصور الخاص للفعاليات. تنشئ "فيلم" (حدث)، تدعو الضيوف برمز QR، والجميع يلتقطون الصور طوال اليوم. الصور مخفية حتى ينتهي الحدث، ثم تُكشف للجميع دفعة واحدة.',
    faq2Q: 'هل يمكنني استخدام Momira على هاتف Android؟',
    faq2A: 'نعم! Momira يعمل على أي جهاز مع متصفح ويب. يمكن للضيوف الانضمام عبر رمز QR دون تحميل أي شيء.',
    faq3Q: 'كيف أنشئ فيلم على Momira؟',
    faq3A: 'سجل برقم هاتفك، اضغط "حدث جديد"، سمّ فيلمك، اختر النوع، حدد المدة التي سيبقى مفتوحًا، وشارك رمز QR مع ضيوفك.',
    faq4Q: 'هل يمكن للأصدقاء الانضمام دون إنشاء حساب؟',
    faq4A: 'يحتاج الضيوف لتسجيل الدخول برقم هاتفهم لرفع الصور وعرض الألبوم. هذا يضمن الخصوصية والأمان لفعاليتك.',
    faq5Q: 'من يمكنه رؤية الصور التي أرفعها؟',
    faq5A: 'الضيوف المدعوون لفعاليتك فقط يمكنهم رؤية الصور. فعاليتك خاصة افتراضيًا. يمكن للمضيفين مراجعة والموافقة على الصور قبل ظهورها.',
    faq6Q: 'كم يستغرق تطوير الفيلم؟',
    faq6A: 'تُكشف الصور تلقائيًا في الوقت الذي تحدده عند إنشاء الحدث. يمكنك اختيار كشفها فور انتهاء الحدث أو في تاريخ محدد.',
    faq7Q: 'هل يمكنني تنزيل صوري بعد تطوير الفيلم؟',
    faq7A: 'نعم — نزّل الألبوم الكامل بصيغة ZIP أو احفظه مباشرة على Google Drive. كل صورة محفوظة بدقتها الأصلية.',
    faq8Q: 'ما أنواع اللحظات التي تناسب Momira؟',
    faq8A: 'Momira مثالي للأعراس، أعياد الميلاد، الرحلات، الحفلات، الفعاليات المؤسسية، وأي مناسبة خاصة تريد تذكرها معًا.',
    faq9Q: 'لماذا يسمى Momira؟',
    faq9A: 'Momira يمثل "اللحظات" و"الذاكرة" — التقاط اللحظات التي تصبح ذكريات نعتز بها للأبد.',
    // Auth
    phoneAuth: 'تسجيل الدخول برقم الهاتف',
    passwordAuth: 'تسجيل الدخول بكلمة المرور',
    sendCode: 'إرسال الرمز',
    verifyCode: 'تحقق من الرمز',
    resendCode: 'إعادة الإرسال',
    enterPhone: 'أدخل رقم الهاتف',
    enterCode: 'أدخل رمز التحقق',
    enterPassword: 'أدخل كلمة المرور',
    setPassword: 'تعيين كلمة المرور',
    updatePassword: 'تحديث كلمة المرور',
    passwordMinChars: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
    otpSent: 'تم إرسال الرمز! تحقق من رسائلك.',
    loginSuccess: 'تم تسجيل الدخول بنجاح!',
    welcomeToMomira: 'مرحبًا بك في Momira!',
    passwordSaved: 'تم حفظ كلمة المرور! يمكنك استخدامها في المرة القادمة.',
    passwordUpdated: 'تم تحديث كلمة المرور!',
    invalidPhone: 'الرجاء إدخال رقم هاتف صالح مع رمز الدولة',
    invalidOtp: 'الرجاء إدخال رمز OTP',
    invalidVerification: 'التحقق غير صالح. حاول مرة أخرى.',
    tooManyAttempts: 'محاولات كثيرة جدًا',
    tooManyAttemptsDesc: 'الرجاء الانتظار بضع دقائق قبل المحاولة مرة أخرى.',
    invalidPhoneFormat: 'تنسيق رقم الهاتف غير صالح',
    invalidPhoneFormatDesc: 'أدخل رقمك الكامل مع رمز الدولة، مثل +966501234567. بدون مسافات.',
    failedSendOtp: 'فشل إرسال OTP',
    invalidOtpCode: 'رمز OTP غير صالح',
    failedSavePassword: 'فشل حفظ كلمة المرور',
    failedUpdatePassword: 'فشل تحديث كلمة المرور',
    emailPasswordDisabled: 'تسجيل الدخول بالبريد الإلكتروني/كلمة المرور معطل في Firebase Console.',
    emailPasswordDisabledDesc: 'اذهب إلى Authentication > Sign-in method وقم بتمكين "Email/Password".',
    welcomeBack: 'مرحبًا بعودتك!',
    enterYourPassword: 'الرجاء إدخال كلمة المرور',
    invalidPhoneNoCountry: 'تنسيق رقم الهاتف غير صالح',
    invalidPhoneNoCountryDesc: 'أدخل رقمك الكامل مع رمز الدولة، مثل +966501234567',
    invalidPhoneOrPassword: 'رقم الهاتف أو كلمة المرور غير صالحة',
    invalidPhoneOrPasswordDesc: 'لم يتم العثور على كلمة مرور لهذا الرقم. سجل الدخول بـ OTP أولاً لتعيين كلمة مرور.',
    emailPasswordDisabledAlt: 'تسجيل الدخول بالبريد الإلكتروني/كلمة المرور معطل',
    emailPasswordDisabledAltDesc: 'اطلب من المشرف تمكينه في Firebase Console > Authentication > Sign-in method.',
    invalidPhoneOrPasswordAlt: 'رقم الهاتف أو كلمة المرور غير صالحة',
    eventNamePlaceholder: 'سارة ومايك زفاف',
    descriptionPlaceholder: 'بعض الكلمات عن فعاليتك...',
    fillRequiredFields: 'الرجاء ملء جميع الحقول المطلوبة',
    signInFirst: 'الرجاء تسجيل الدخول أولاً',
    eventCreated: 'تم إنشاء الفعالية بنجاح',
    failedCreateEvent: 'فشل إنشاء الفعالية',
    // Dashboard
    yourEvents: 'فعالياتك',
    noEvents: 'لا توجد فعاليات',
    createEvent: 'إنشاء فعالية',
    newEvent: 'فعالية جديدة',
    scanQR: 'مسح QR',
    pending: 'معلق',
    gallery: 'معرض الصور',
    events: 'الفعاليات',
    noDate: 'لا يوجد تاريخ',
    failedLoadEvents: 'فشل تحميل الفعاليات',
    noPhone: 'لا يوجد هاتف',
    notSet: 'لم يتم التعيين',
    recently: 'مؤخرًا',
    enableEmailPassword: 'قم بتمكينه في Authentication > Sign-in method.',
    failedGenerateAlbum: 'فشل إنشاء الألبوم',
    failedDeleteEvent: 'فشل حذف الفعالية',
    failedLoadAnalytics: 'فشل تحميل التحليلات',
    aiCurationFailed: 'فشل التنقيح بالذكاء الاصطناعي',
    failedGenerateReel: 'فشل إنشاء فيديو المميزات',
    allowPopups: 'الرجاء السماح بالنوافذ المنبثقة لربط Google Drive',
    // Pricing features
    pricingFeature1: 'ينضم الضيوف عبر رمز QR أو رابط (بدون تنزيل تطبيق)',
    pricingFeature2: 'صور غير محدودة لكل ضيف',
    pricingFeature3: 'حدد مدة بقاء الفيلم مفتوحاً',
    pricingFeature4: 'خاص وآمن — الضيوف المدعوون فقط يرون الصور',
    pricingFeature5: 'مشاركة رمز QR بنقرة واحدة',
    pricingFeature6: 'فلاتر الصور والتنقيح بالذكاء الاصطناعي',
    pricingFeature7: 'اعرف بالضبط من التقط كل صورة',
    pricingFeature8: 'تنزيل الألبوم كاملاً بعد الكشف',
    // Pricing FAQs
    pricingFaq1Q: 'ما هو Momira وكيف يعمل؟',
    pricingFaq1A: 'Momira هو تطبيق مشاركة صور خاص للفعاليات. تنشئ "فيلماً" (فعالية)، تدعو الضيوف برمز QR، ويلتقط الجميع الصور طوال اليوم. الصور مخفية حتى تنتهي الفعالية، ثم تُكشف للجميع دفعة واحدة.',
    pricingFaq2Q: 'هل يمكنني استخدام Momira على هاتف Android؟',
    pricingFaq2A: 'نعم! يعمل Momira على أي جهاز يحتوي على متصفح ويب. يمكن للضيوف الانضمام عبر رمز QR دون تنزيل أي شيء. التطبيق متوافق مع iOS وAndroid.',
    pricingFaq3Q: 'كيف أنشئ فيلماً على Momira؟',
    pricingFaq3A: 'سجل برقم هاتفك، اضغط "فعالية جديدة"، سمِّ فيلمك، اختر النوع (زفاف، حفلة، رحلة، إلخ)، حدد مدة بقائه مفتوحاً، وشارك رمز QR مع ضيوفك.',
    pricingFaq4Q: 'هل يمكن للأصدقاء الانضمام بدون إنشاء حساب؟',
    pricingFaq4A: 'يحتاج الضيوف إلى تسجيل الدخول برقم هاتفهم لرفع الصور ومشاهدة الألبوم. هذا يضمن خصوصية وأمان فعاليتك.',
    pricingFaq5Q: 'من يمكنه رؤية الصور التي أرفعها؟',
    pricingFaq5A: 'فقط الضيوف المدعوون لفعاليتك يمكنهم رؤية الصور. فعاليتك خاصة افتراضياً. يمكن للمضيف مراجعة الصور والموافقة عليها قبل ظهورها.',
    pricingFaq6Q: 'كم من الوقت يستغرق تطوير الفيلم؟',
    pricingFaq6A: 'أنت تحدد وقت الكشف عند إنشاء الفعالية. يمكن أن يكون فورياً، أو بعد ساعات، أو حتى أيام لاحقة. الترقب هو نصف المتعة!',
    pricingFaq7Q: 'هل يمكنني تنزيل صوري بعد تطوير الفيلم؟',
    pricingFaq7A: 'نعم، يمكنك تنزيل الألبوم كاملاً كملف مضغوط بعد الكشف. كل صورة محفوظة بجودة عالية.',
    pricingFaq8Q: 'ما أنواع اللحظات التي يناسبها Momira؟',
    pricingFaq8A: 'الأعراس، أعياد الميلاد، الحفلات، الرحلات، فعاليات الشركات، الحفلات الموسيقية — أي لحظة يلتقط فيها أشخاص متعددون ذكريات معاً.',
    pricingFaq9Q: 'لماذا سُمي بـ Momira؟',
    pricingFaq9A: 'لأن الحياة تحدث Momira. كل لحظة فريدة ولا تعوض. Momira يساعدك على التقاط هذه اللحظات من عيون الجميع، ليس عينيك فقط.',
    classicWedding: 'زفاف كلاسيكي',
    classicWeddingDesc: 'فعالية خاصة مع موافقة المضيف على كل صورة. مثالي للأعراس الفاخرة.',
    birthdayBash: 'حفلة عيد ميلاد',
    birthdayBashDesc: 'مرح وعفوي. الموافقة التلقائية على الصور لكي لا تتوقف الحفلة!',
    adventureTrip: 'رحلة مغامرة',
    adventureTripDesc: 'شارك ذكريات السفر مع الأصدقاء. حدود معتدلة للرحلات الجماعية.',
    corporateEvent: 'فعالية شركات',
    corporateEventDesc: 'بيئة احترافية مع موافقة صارمة لسلامة العلامة التجارية.',
    graduationDay: 'يوم التخرج',
    graduationDayDesc: 'التقط كل رمي للقب ولحظات فخر. مشاركة عامة.',
    engagementParty: 'حفلة خطوبة',
    engagementPartyDesc: 'لحظات رومانسية فقط — المضيف يوافق على كل لقطة.',
    // Admin
    adminDashboard: 'لوحة تحكم المشرف',
    overview: 'نظرة عامة',
    photos: 'الصور',
    guests: 'الضيوف',
    analytics: 'التحليلات',
    totalEvents: 'إجمالي الفعاليات',
    totalPhotos: 'إجمالي الصور',
    activeGuests: 'الضيوف النشطون',
    pendingPhotos: 'الصور المعلقة',
    approvalQueue: 'قائمة الموافقة',
    recentGuests: 'أحدث الضيوف',
    allEvents: 'كل الفعاليات',
    eventManagement: 'إدارة الفعاليات',
    photoApproval: 'قائمة موافقة الصور',
    guestManagement: 'إدارة الضيوف',
    approve: 'موافقة',
    reject: 'رفض',
    remove: 'إزالة',
    noPendingPhotos: 'لا توجد صور معلقة',
    noGuests: 'لا يوجد ضيوف',
    // Settings
    profile: 'الملف الشخصي',
    password: 'كلمة المرور',
    passwordSet: 'تم التعيين',
    joined: 'تاريخ الانضمام',
    administrator: 'مدير',
    backToDashboard: 'العودة للوحة التحكم',
    // Event Modal
    eventDetails: 'تفاصيل الحدث',
    type: 'النوع',
    status: 'الحالة',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    revealDate: 'تاريخ الكشف',
    maxPhotosPerGuest: 'الحد الأقصى للصور/ضيف',
    approval: 'الموافقة',
    approvalRequired: 'مطلوبة',
    approvalAuto: 'تلقائية',
    privateEvent: 'فعالية خاصة',
    guestSharing: 'مشاركة الضيوف',
    yes: 'نعم',
    no: 'لا',
    on: 'مفعل',
    off: 'معطل',
    identifiers: 'المعرفات',
    eventId: 'رقم الفعالية',
    qrCode: 'رمز QR',
    links: 'روابط',
    viewEvent: 'عرض الفعالية',
    qrPage: 'صفحة QR',
    copyLink: 'نسخ الرابط',
    dates: 'التواريخ',
    // Create Event
    dateTime: 'التاريخ والوقت',
    privacyPermissions: 'الخصوصية والصلاحيات',
    creating: 'جاري الإنشاء...',
    eventName: 'اسم الفعالية',
    description: 'الوصف',
    continue: 'متابعة',
    albumRevealDate: 'تاريخ كشف الألبوم',
    requireHostApproval: 'موافقة المضيف مطلوبة',
    allowGuestSharing: 'السماح بمشاركة الضيوف',
    albumRevealDateDesc: 'متى يجب كشف الصور للضيوف؟',
    autoApproveTrustedGuests: 'الموافقة التلقائية للضيوف الموثوقين',
    allowCoHost: 'السماح بالمضيفين المساعدين',
    allowCoHostDesc: 'يمكن للضيوف المساعدة في إدارة الفعالية',
    // Pricing
    choosePlan: 'اختر خطة',
    pricingDesc: 'تدفع مرة واحدة فقط لكل فعالية. لا اشتراكات، لا تجديدات.',
    participants: 'المشاركون',
    free: 'مجانًا',
    perEvent: 'لكل فعالية',
    featuresIncluded: 'ما هو مشمول',
    upToParticipants: 'حتى',
    canJoin: 'يمكنهم الانضمام للفعالية',
    createFreeEvent: 'أنشئ فعالية مجانية',
    noCreditCard: 'لا حاجة لبطاقة ائتمان للفعاليات المجانية',
    // QR
    manualEntry: 'الإدخال اليدوي',
    enterEventCode: 'أدخل رقم الفعالية',
    join: 'انضم للفعالية',
    joining: 'جاري الانضمام...',
    joinSuccess: 'تم الانضمام للفعالية بنجاح!',
    joinFailed: 'فشل الانضمام للفعالية',
    joiningEvent: 'تم العثور على الفعالية! جاري الانضمام...',
    alreadyInEvent: 'أنت بالفعل في هذه الفعالية!',
    scanOrEnter: 'امسح رمز QR أو أدخل رقم الفعالية يدويًا.',
    tapToScan: 'اضغط لبدء المسح',
    cameraAccessDenied: 'تم رفض الوصول للكاميرا. يرجى استخدام الإدخال اليدوي.',
    // Camera
    takePhoto: 'التقط صورة',
    retake: 'إعادة التقاط',
    upload: 'رفع',
    remainingShots: 'اللقطات المتبقية',
    shotsLeft: 'لقطة متبقية',
    payAndCreate: 'ادفع وأنشئ فعالية',
    noEventSelected: 'لم يتم اختيار فعالية',
    goToDashboard: 'الذهاب للوحة التحكم',
    photoUploaded: 'تم رفع الصورة!',
    uploadFailed: 'فشل الرفع',
    // Event Detail
    like: 'إعجاب',
    comment: 'تعليق',
    download: 'تحميل',
    all: 'الكل',
    yours: 'خاصتك',
    social: 'اجتماعي',
    grid: 'شبكة',
    list: 'قائمة',
    eventNotFound: 'لم يتم العثور على الفعالية',
    failedToLoadEvent: 'فشل تحميل الفعالية',
    checkOutPhoto: 'شاهد هذه الصورة من فعاليتنا!',
    publicEvent: 'عامة',
    scanToJoin: 'امسح للانضمام للفعالية',
    eventCode: 'رمز الفعالية',
    allPhotos: 'جميع الصور',
    shareThisEvent: 'شارك هذه الفعالية',
    spreadTheWord: 'انشر الخبر واحصل على المزيد من الضيوف!',
    photoChallenges: 'تحديات الصور',
    shares: 'مشاركات',
    reach: 'وصول',
    engagement: 'تفاعل',
    sharingEnabled: 'المشاركة مفعلة',
    noPhotosYet: 'لا توجد صور بعد',
    takeFirstPhoto: 'التقط أول صورة',
    albumLocked: 'الألبوم مقفل حتى وقت الكشف',
    revealsOn: 'يكشف في',
    aiCurationComplete: 'اكتمل اختيار الصور بالذكاء الاصطناعي!',
    totalGuests: 'إجمالي الضيوف',
    approved: 'معتمد',
    topUploaders: 'أكثر من يرفع صوراً',
    confirmDelete: 'هل أنت متأكد أنك تريد حذف هذه الفعالية؟',
    eventDeleted: 'تم حذف الفعالية',
    noChallengesYet: 'لا توجد تحديات بعد',
    hostCanCreate: 'المضيف يمكنه إنشاء تحديات الصور',
    addComment: 'أضف تعليقاً...',
    post: 'نشر',
    templates: 'قوالب جاهزة',
    maxGuests: 'الحد الأقصى للضيوف',
    maxGuestsDesc: 'الضيوف بعد هذا الحد سيحتاجون ترقية.',
    guestbook: 'سجل الزوار',
    emailInvite: 'دعوة بالبريد الإلكتروني',
    sendInvite: 'إرسال',
    leaveAMessage: 'اترك رسالة للمضيف',
    writeMessage: 'اكتب رسالة...',
    send: 'إرسال',
    watermarkText: 'نص العلامة المائية',
    watermarkDesc: 'النص الذي سيظهر على الصور المحملة.',
  },
  fr: {
    // Common
    appName: 'Momira',
    close: 'Fermer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    view: 'Voir',
    copy: 'Copier',
    copied: 'Copié !',
    settings: 'Paramètres',
    signOut: 'Déconnexion',
    back: 'Retour',
    search: 'Rechercher',
    filter: 'Filtrer',
    export: 'Exporter',
    share: 'Partager',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    // Landing
    heroTitle: 'Un Événement, Une Belle Histoire',
    heroSubtitle: 'Collectionnez chaque instant de chaque invité. Rassemblement de photos de qualité professionnelle pour vos occasions spéciales.',
    getStarted: 'Commencer',
    howItWorks: 'Comment ça marche',
    step1Title: 'Créez Votre Événement',
    step1Desc: 'Configurez votre événement en secondes avec un QR code unique pour les invités.',
    step2Title: 'Les invités rejoignent et téléchargent',
    step2Desc: 'Les invités scannent votre QR code et téléchargent des photos instantanément.',
    step3Title: 'Sélectionnez et partagez',
    step3Desc: 'Révisez, sélectionnez et partagez les meilleurs moments avec tout le monde.',
    features: 'Tout ce dont vous avez besoin',
    everythingYouNeed: 'Tout ce dont vous avez besoin. Rien de superflu.',
    feature1Title: 'Capturez ensemble',
    feature1Desc: 'Les invités rejoignent via QR code et capturent de tous les angles.',
    feature2Title: 'Révélation différée',
    feature2Desc: 'Les photos restent scellées jusqu\'à la fin du moment, créant du suspense.',
    feature3Title: 'Privé et sécurisé',
    feature3Desc: 'Seuls les invités voient votre album. Confidentialité de bout en bout.',
    feature4Title: 'Effets photo IA',
    feature4Desc: 'Cinématique, Anime, N&B, Slow-Mo — 10 modèles Higgsfield.',
    feature5Title: 'Curation intelligente',
    feature5Desc: 'L\'IA choisit les meilleurs clichés et assemble un highlight reel.',
    feature6Title: 'Partage en un tap',
    feature6Desc: 'Instagram, TikTok, Snapchat — partagez en un seul tap.',
    pricing: 'Tarifs',
    faq: 'Questions Fréquentes',
    everythingYouWantedToKnow: 'Tout ce que vous vouliez savoir.',
    testimonials: 'Témoignages',
    lovedByHosts: 'Apprécié par les hôtes du monde entier',
    login: 'Connexion',
    createYourEvent: 'Créer votre événement',
    joinAnEvent: 'Rejoindre un événement',
    captureYourDay: 'Immortalisez vos moments',
    throughEveryonesEyes: "vus par tous les regards.",
    premiumPrivatePhotoSharing: 'Momira est une application premium et privée de partage de photos pour événements. Les invités rejoignent via QR code, prennent des photos mémorables, et l\'album se révèle après l\'événement.',
    nowWithAI: 'Maintenant avec curation photo IA',
    chooseHowToUse: 'Choisissez comment utiliser Momira',
    user: 'Utilisateur',
    guest: 'Invité',
    host: 'Hôte',
    admin: 'Admin',
    flash: 'Flash',
    userDesc: 'Créez des événements, invitez des invités et gérez vos albums.',
    guestDesc: 'Scannez un QR code ou entrez un code d\'événement pour rejoindre et partager des photos.',
    adminDesc: 'Gérez tous les événements, approuvez les photos et consultez les analyses.',
    howADayBecomes: 'Comment une journée devient un film.',
    threeSimpleSteps: 'Trois étapes simples. Zéro friction.',
    step: 'ÉTAPE',
    createAFilm: 'Créez un film',
    inviteYourPeople: 'Invitez vos proches',
    captureTogether: 'Capturez ensemble',
    createFilmDesc: 'Nommez votre film, définissez sa durée d\'ouverture et le type de moment.',
    inviteDesc: 'Partagez le lien de votre film ou le QR code et invitez des amis à capturer la journée avec vous.',
    captureDesc: 'Prenez des photos tout au long de la journée, chaque cliché remplit votre pellicule partagée.',
    perfectForEveryMoment: 'Parfait pour chaque moment.',
    fromWhisperedToNeon: 'Des chuchotements "je le veux" aux pistes de danse néon.',
    wedding: 'Mariage',
    birthday: 'Anniversaire',
    trip: 'Voyage',
    party: 'Fête',
    corporate: 'Entreprise',
    other: 'Autre',
    weddingDesc: 'Capturez chaque émotion de chaque invité.',
    birthdayDesc: 'Voyez la fête sous tous les angles.',
    tripDesc: 'Collectez les souvenirs de voyage ensemble.',
    partyDesc: 'Les meilleurs moments candides, garantis.',
    lifeHappens: 'La vie ne se vit qu\'une fois.',
    dontLetItFade: 'Ne la laissez pas s\'effacer.',
    startFirstEvent: 'Commencez votre premier événement en moins de 60 secondes. Gratuit jusqu\'à 50 invités.',
    seePricing: 'Voir les tarifs',
    createForFree: 'Créer gratuitement',
    footerTagline: 'Une seule journée devient intemporelle, lorsqu\'on s\'en souvient ensemble.',
    faq1Q: 'Qu\'est-ce que Momira et comment ça marche ?',
    faq1A: 'Momira est une application privée de partage de photos pour événements. Vous créez un "film" (événement), invitez les invités avec un QR code, et tout le monde capture des photos tout au long de la journée. Les photos sont cachées jusqu\'à la fin de l\'événement, puis révélées à tous en même temps.',
    faq2Q: 'Puis-je utiliser Momira sur un téléphone Android ?',
    faq2A: 'Oui ! Momira fonctionne sur n\'importe quel appareil avec un navigateur web. Les invités peuvent rejoindre via QR code sans rien télécharger.',
    faq3Q: 'Comment créer un film sur Momira ?',
    faq3A: 'Inscrivez-vous avec votre numéro de téléphone, appuyez sur "Nouvel événement", nommez votre film, choisissez le type, définissez la durée d\'ouverture, et partagez le QR code avec vos invités.',
    faq4Q: 'Les amis peuvent-ils rejoindre sans créer de compte ?',
    faq4A: 'Les invités doivent se connecter avec leur numéro de téléphone pour télécharger des photos et voir l\'album. Cela garantit la confidentialité et la sécurité de votre événement.',
    faq5Q: 'Qui peut voir les photos que je télécharge ?',
    faq5A: 'Seuls les invités à votre événement peuvent voir les photos. Votre événement est privé par défaut. Les hôtes peuvent réviser et approuver les photos avant leur apparition.',
    faq6Q: 'Combien de temps faut-il pour qu\'un film se développe ?',
    faq6A: 'Les photos sont révélées automatiquement à l\'heure que vous définissez lors de la création de l\'événement. Vous pouvez choisir de les révéler immédiatement après la fin de l\'événement ou à une date spécifique.',
    faq7Q: 'Puis-je télécharger mes photos après le développement du film ?',
    faq7A: 'Oui — téléchargez l\'album ZIP complet ou sauvegardez-le directement sur Google Drive. Chaque photo est préservée à sa résolution originale.',
    faq8Q: 'Quels types de moments conviennent le mieux à Momira ?',
    faq8A: 'Momira est parfait pour les mariages, anniversaires, voyages, fêtes, événements d\'entreprise, et toute occasion spéciale que vous voulez remember ensemble.',
    faq9Q: 'Pourquoi s\'appelle-t-il Momira ?',
    faq9A: 'Momira représente "Moments" et "Mémoire" — capturer les moments qui deviennent des souvenirs que nous chérissons pour toujours.',
    // Auth
    phoneAuth: 'Authentification par téléphone',
    passwordAuth: 'Authentification par mot de passe',
    sendCode: 'Envoyer le code',
    verifyCode: 'Vérifier le code',
    resendCode: 'Renvoyer',
    enterPhone: 'Entrez votre numéro de téléphone',
    enterCode: 'Entrez le code de vérification',
    enterPassword: 'Entrez le mot de passe',
    setPassword: 'Définir le mot de passe',
    updatePassword: 'Modifier le mot de passe',
    passwordMinChars: 'Le mot de passe doit contenir au moins 6 caractères',
    otpSent: 'Code envoyé ! Vérifiez vos messages.',
    loginSuccess: 'Connexion réussie !',
    welcomeToMomira: 'Bienvenue sur Momira !',
    passwordSaved: 'Mot de passe enregistré ! Vous pouvez l\'utiliser la prochaine fois.',
    passwordUpdated: 'Mot de passe mis à jour !',
    invalidPhone: 'Veuillez entrer un numéro de téléphone valide avec l\'indicatif du pays',
    invalidOtp: 'Veuillez entrer le code OTP',
    invalidVerification: 'Vérification invalide. Veuillez réessayer.',
    tooManyAttempts: 'Trop de tentatives',
    tooManyAttemptsDesc: 'Veuillez attendre quelques minutes avant de réessayer.',
    invalidPhoneFormat: 'Format de numéro de téléphone invalide',
    invalidPhoneFormatDesc: 'Entrez votre numéro complet avec l\'indicatif du pays, ex: +966501234567. Sans espaces.',
    failedSendOtp: 'Échec de l\'envoi du code OTP',
    invalidOtpCode: 'Code OTP invalide',
    failedSavePassword: 'Échec de l\'enregistrement du mot de passe',
    failedUpdatePassword: 'Échec de la mise à jour du mot de passe',
    emailPasswordDisabled: 'La connexion par email/mot de passe est désactivée dans Firebase Console.',
    emailPasswordDisabledDesc: 'Allez dans Authentication > Sign-in method et activez "Email/Password".',
    welcomeBack: 'Bon retour !',
    enterYourPassword: 'Veuillez entrer votre mot de passe',
    invalidPhoneNoCountry: 'Format de numéro de téléphone invalide',
    invalidPhoneNoCountryDesc: 'Entrez votre numéro complet avec l\'indicatif du pays, ex: +966501234567',
    invalidPhoneOrPassword: 'Numéro de téléphone ou mot de passe invalide',
    invalidPhoneOrPasswordDesc: 'Aucun mot de passe trouvé pour ce numéro. Connectez-vous avec OTP d\'abord pour définir un mot de passe.',
    emailPasswordDisabledAlt: 'La connexion par email/mot de passe est désactivée',
    emailPasswordDisabledAltDesc: 'Demandez à l\'admin de l\'activer dans Firebase Console > Authentication > Sign-in method.',
    invalidPhoneOrPasswordAlt: 'Numéro de téléphone ou mot de passe invalide',
    eventNamePlaceholder: 'Sarah & Mike Mariage',
    descriptionPlaceholder: 'Quelques mots sur votre événement...',
    fillRequiredFields: 'Veuillez remplir tous les champs requis',
    signInFirst: 'Veuillez vous connecter d\'abord',
    eventCreated: 'Événement créé avec succès',
    failedCreateEvent: 'Échec de la création de l\'événement',
    // Dashboard
    yourEvents: 'Vos Événements',
    noEvents: 'Aucun événement',
    createEvent: 'Créer un événement',
    newEvent: 'Nouvel événement',
    scanQR: 'Scanner QR',
    pending: 'En attente',
    gallery: 'Galerie',
    events: 'Événements',
    noDate: 'Pas de date',
    failedLoadEvents: 'Échec du chargement des événements',
    noPhone: 'Pas de téléphone',
    notSet: 'Non défini',
    recently: 'Récemment',
    enableEmailPassword: 'Activez-le dans Authentication > Sign-in method.',
    failedGenerateAlbum: 'Échec de la génération de l\'album',
    failedDeleteEvent: 'Échec de la suppression de l\'événement',
    failedLoadAnalytics: 'Échec du chargement des analyses',
    aiCurationFailed: 'Échec de la curation IA',
    failedGenerateReel: 'Échec de la génération du highlight reel',
    allowPopups: 'Veuillez autoriser les popups pour connecter Google Drive',
    // Pricing features
    pricingFeature1: 'Les invités rejoignent via QR code ou lien (sans télécharger d\'app)',
    pricingFeature2: 'Photos illimitées par invité',
    pricingFeature3: 'Définissez la durée d\'ouverture de votre film',
    pricingFeature4: 'Privé et sécurisé — seuls les invités voient les photos',
    pricingFeature5: 'Partage QR code en un tap',
    pricingFeature6: 'Filtres photo et curation IA',
    pricingFeature7: 'Voyez exactement qui a pris chaque photo',
    pricingFeature8: 'Téléchargez l\'album complet après la révélation',
    // Pricing FAQs
    pricingFaq1Q: 'Qu\'est-ce que Momira et comment ça fonctionne?',
    pricingFaq1A: 'Momira est une app de partage de photos privée pour les événements. Vous créez un "film" (événement), invitez des invités avec un QR code, et tout le monde prend des photos. Les photos sont cachées jusqu\'à la fin de l\'événement, puis révélées à tous en même temps.',
    pricingFaq2Q: 'Puis-je utiliser Momira sur Android?',
    pricingFaq2A: 'Oui! Momira fonctionne sur tout appareil avec un navigateur web. Les invités peuvent rejoindre via QR code sans rien télécharger. L\'app est compatible iOS et Android.',
    pricingFaq3Q: 'Comment créer un film sur Momira?',
    pricingFaq3A: 'Inscrivez-vous avec votre numéro de téléphone, appuyez sur "Nouvel événement", nommez votre film, choisissez le type, définissez sa durée, et partagez le QR code avec vos invités.',
    pricingFaq4Q: 'Les amis peuvent-ils rejoindre sans créer un compte?',
    pricingFaq4A: 'Les invités doivent se connecter avec leur numéro de téléphone pour uploader des photos et voir l\'album. Cela garantit la confidentialité et la sécurité de votre événement.',
    pricingFaq5Q: 'Qui peut voir les photos que je télécharge?',
    pricingFaq5A: 'Seuls les invités conviés à votre événement peuvent voir les photos. Votre événement est privé par défaut. L\'hôte peut examiner et approuver les photos.',
    pricingFaq6Q: 'Combien de temps faut-il pour que le film se développe?',
    pricingFaq6A: 'Vous définissez l\'heure de révélation à la création. Cela peut être immédiat, après quelques heures, ou même des jours plus tard. L\'anticipation c\'est la moitié du plaisir!',
    pricingFaq7Q: 'Puis-je télécharger mes photos après le développement?',
    pricingFaq7A: 'Oui, vous pouvez télécharger l\'album complet en zip une fois révélé. Chaque photo est conservée en haute qualité.',
    pricingFaq8Q: 'Pour quels types de moments Momira est-il le mieux adapté?',
    pricingFaq8A: 'Mariages, anniversaires, fêtes, voyages, événements d\'entreprise, concerts — tout moment où plusieurs personnes capturent des souvenirs ensemble.',
    pricingFaq9Q: 'Pourquoi s\'appelle-t-il Momira?',
    pricingFaq9A: 'Parce que la vie se passe Momira. Chaque moment est unique et irremplaçable. Momira vous aide à capturer ces moments à travers les yeux de tous.',
    classicWedding: 'Mariage Classique',
    classicWeddingDesc: 'Événement privé avec approbation de l\'hôte pour chaque photo. Parfait pour les mariages élégants.',
    birthdayBash: 'Fête d\'Anniversaire',
    birthdayBashDesc: 'Amusant et décontracté. Approbation automatique des photos pour que la fête ne s\'arrête jamais!',
    adventureTrip: 'Voyage d\'Aventure',
    adventureTripDesc: 'Partagez vos souvenirs de voyage avec des amis. Limites modérées pour les voyages en groupe.',
    corporateEvent: 'Événement d\'Entreprise',
    corporateEventDesc: 'Cadre professionnel avec approbation stricte pour la sécurité de la marque.',
    graduationDay: 'Jour de Remise des Diplômes',
    graduationDayDesc: 'Capturez chaque lancer de chapeau et moment de fierté. Partage public activé.',
    engagementParty: 'Fête de Fiançailles',
    engagementPartyDesc: 'Moments romantiques uniquement — l\'hôte approuve chaque photo.',
    // Admin
    adminDashboard: 'Tableau de bord Admin',
    overview: 'Vue d\'ensemble',
    photos: 'Photos',
    guests: 'Invités',
    analytics: 'Analyses',
    totalEvents: 'Total Événements',
    totalPhotos: 'Total Photos',
    activeGuests: 'Invités actifs',
    pendingPhotos: 'Photos en attente',
    approvalQueue: 'File d\'attente d\'approbation',
    recentGuests: 'Invités récents',
    allEvents: 'Tous les événements',
    eventManagement: 'Gestion des événements',
    photoApproval: 'File d\'attente de photos',
    guestManagement: 'Gestion des invités',
    approve: 'Approuver',
    reject: 'Rejeter',
    remove: 'Retirer',
    noPendingPhotos: 'Aucune photo en attente',
    noGuests: 'Aucun invité',
    // Settings
    profile: 'Profil',
    password: 'Mot de passe',
    passwordSet: 'Défini',
    joined: 'Inscrit le',
    administrator: 'Administrateur',
    backToDashboard: 'Retour au tableau de bord',
    // Event Modal
    eventDetails: 'Détails de l\'événement',
    type: 'Type',
    status: 'Statut',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    revealDate: 'Date de révélation',
    maxPhotosPerGuest: 'Max Photos/Invité',
    approval: 'Approbation',
    approvalRequired: 'Requise',
    approvalAuto: 'Auto',
    privateEvent: 'Événement privé',
    guestSharing: 'Partage invités',
    yes: 'Oui',
    no: 'Non',
    on: 'Activé',
    off: 'Désactivé',
    identifiers: 'Identifiants',
    eventId: 'ID Événement',
    qrCode: 'QR Code',
    links: 'Liens',
    viewEvent: 'Voir l\'événement',
    qrPage: 'Page QR',
    copyLink: 'Copier le lien',
    dates: 'Dates',
    // Create Event
    dateTime: 'Date & Heure',
    privacyPermissions: 'Confidentialité & Permissions',
    creating: 'Création...',
    eventName: 'Nom de l\'événement',
    description: 'Description',
    continue: 'Continuer',
    albumRevealDate: 'Date de révélation',
    requireHostApproval: 'Approbation de l\'hôte requise',
    allowGuestSharing: 'Autoriser le partage invités',
    albumRevealDateDesc: 'Quand les photos doivent-elles être révélées aux invités ?',
    autoApproveTrustedGuests: 'Approuver auto. les invités de confiance',
    allowCoHost: 'Autoriser les co-hôtes',
    allowCoHostDesc: 'Les invités peuvent aider à gérer l\'événement',
    // Pricing
    choosePlan: 'Choisir un plan',
    pricingDesc: 'Vous ne payez qu\'une fois par événement. Pas d\'abonnement, pas de renouvellement.',
    participants: 'Participants',
    free: 'Gratuit',
    perEvent: 'par événement',
    featuresIncluded: 'Ce qui est inclus',
    upToParticipants: 'Jusqu\'à',
    canJoin: 'peuvent rejoindre votre événement',
    createFreeEvent: 'Créer un événement gratuit',
    noCreditCard: 'Pas de carte de crédit requise pour les événements gratuits',
    // QR
    manualEntry: 'Saisie manuelle',
    enterEventCode: 'Entrez le code',
    join: 'Rejoindre l\'événement',
    joining: 'Rejoindre l\'événement...',
    joinSuccess: 'Vous avez rejoint l\'événement avec succès !',
    joinFailed: 'Échec de la participation à l\'événement',
    joiningEvent: 'Événement trouvé ! Participation...',
    alreadyInEvent: 'Vous êtes déjà dans cet événement !',
    scanOrEnter: 'Scannez un QR code ou entrez le code manuellement.',
    tapToScan: 'Appuyez pour scanner',
    cameraAccessDenied: 'Accès caméra refusé. Utilisez la saisie manuelle.',
    // Camera
    takePhoto: 'Prendre photo',
    retake: 'Reprendre',
    upload: 'Télécharger',
    remainingShots: 'Photos restantes',
    shotsLeft: 'photos restantes',
    payAndCreate: 'Payer et créer l\'événement',
    noEventSelected: 'Aucun événement sélectionné',
    goToDashboard: 'Aller au tableau de bord',
    photoUploaded: 'Photo téléchargée !',
    uploadFailed: 'Échec du téléchargement',
    // Event Detail
    like: 'J\'aime',
    comment: 'Commenter',
    download: 'Télécharger',
    all: 'Tout',
    yours: 'Vos',
    social: 'Social',
    grid: 'Grille',
    list: 'Liste',
    eventNotFound: 'Événement non trouvé',
    failedToLoadEvent: 'Échec du chargement de l\'événement',
    checkOutPhoto: 'Regardez cette photo de notre événement !',
    publicEvent: 'Public',
    scanToJoin: 'Scannez pour rejoindre cet événement',
    eventCode: 'Code de l\'événement',
    allPhotos: 'Toutes les photos',
    shareThisEvent: 'Partager cet événement',
    spreadTheWord: 'Faites passer le mot et invitez plus de monde !',
    photoChallenges: 'Défis photo',
    shares: 'Partages',
    reach: 'Portée',
    engagement: 'Engagement',
    sharingEnabled: 'Partage activé',
    noPhotosYet: 'Pas encore de photos',
    takeFirstPhoto: 'Prendre la première photo',
    albumLocked: 'L\'album est verrouillé jusqu\'au moment de la révélation',
    revealsOn: 'Révélé le',
    aiCurationComplete: 'Curation IA terminée !',
    totalGuests: 'Invités totaux',
    approved: 'Approuvé',
    topUploaders: 'Meilleurs contributeurs',
    confirmDelete: 'Voulez-vous vraiment supprimer cet événement ?',
    eventDeleted: 'Événement supprimé',
    noChallengesYet: 'Aucun défi pour le moment',
    hostCanCreate: "L'hôte peut créer des défis photo",
    addComment: 'Ajouter un commentaire...',
    post: 'Publier',
    templates: 'Modèles rapides',
    maxGuests: 'Invités max',
    maxGuestsDesc: 'Les invités au-delà de cette limite nécessiteront une mise à niveau.',
    guestbook: "Livre d'or",
    emailInvite: 'Inviter par email',
    sendInvite: 'Envoyer',
    leaveAMessage: "Laissez un message pour l'hôte",
    writeMessage: 'Écrivez un message...',
    send: 'Envoyer',
    watermarkText: 'Texte filigrane',
    watermarkDesc: 'Texte à superposer sur les photos téléchargées.',
  },
} as const;

export type TranslationKey = keyof typeof translations.en;

export function t(lang: Lang, key: TranslationKey): string {
  return translations[lang][key] || translations.en[key] || key;
}
